import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const OrderItemsRoutes: Routes = [
  {
    path: "order-items",
    loadComponent: () =>
      import("./order-items/order-items.component").then(
        (m) => m.OrderItemsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./order-items-list/order-items-list.component").then(
            (m) => m.OrderItemsListComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./order-items-form/order-items-form.component").then(
            (m) => m.OrderItemsFormComponent,
          ),
      },
      {
        path: "supplier-order/view/:id",
        loadComponent: () =>
          import("./supplier-order-form/supplier-order-form.component").then(
            (m) => m.SupplierOrderFormComponent,
          ),
      },
    ],
  },
];
